import type { PageHelpContent } from './types';

export const messagesHelp: PageHelpContent = {
  pageGuide: {
    title: 'Как работает раздел Сообщения',
    body: [
      'Здесь собраны все переписки с пациентами из подключённых мессенджеров: WhatsApp, Telegram, MAX и SMS.',
      'Выберите переписку слева, чтобы прочитать и ответить. Используйте фильтры по каналам для быстрого поиска.',
    ],
  },
  expandedGuide: {
    title: '',
    body: [
      'Кнопка «Начать диалог» позволяет написать пациенту первым — выберите канал и введите номер телефона.',
      'Для Telegram Client система автоматически проверит, зарегистрирован ли пациент в Telegram по номеру.',
      'Для WhatsApp WABA вне 24-часового окна сообщение отправляется через шаблон.',
      'MAX (VK) — требуется привязка пациента через бота (команда /start или «Поделиться номером»).',
    ],
    tips: [
      'Индикатор связи (зелёный/красный кружок) показывает состояние WebSocket-подключения.',
      'Бейджи каналов с числом — количество непрочитанных переписок по каждому каналу.',
    ],
  },
  tooltips: {
    channel_waba: 'WhatsApp Business API. Вне 24-часового окна (с последнего сообщения пациента) отправляется через одобренный шаблон.',
    channel_regular: 'WhatsApp через Wazzup. Можно писать первым без ожидания ответа от пациента.',
    channel_tg_bot: 'Telegram Bot. Пациент должен сам написать боту и быть привязан к номеру телефона.',
    channel_tg_client: 'Telegram Client (MTProto). Система ищет пациента по номеру — номер должен быть открыт для поиска в настройках приватности Telegram.',
    channel_max: 'MAX (VK). Требуется привязка пациента — пациент должен написать боту /start и поделиться контактом.',
    channel_sms: 'SMS. Отправка напрямую по номеру телефона. Работает для любого номера.',
    initiate_dialog: 'Начать новую переписку с пациентом. Выберите канал и введите номер телефона.',
    search: 'Поиск по имени пациента, номеру телефона или тексту последнего сообщения.',
    connection_status: 'Состояние WebSocket-подключения. Зелёный — онлайн, сообщения приходят в реальном времени.',
  },
};
